import { render, staticRenderFns } from "./SupplierManagement.vue?vue&type=template&id=70477519&scoped=true"
import script from "./SupplierManagement.vue?vue&type=script&lang=ts"
export * from "./SupplierManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70477519",
  null
  
)

export default component.exports